import InvestDetailPageNew from './InvestDetailPageNew';

export default InvestDetailPageNew;
